import React from 'react';
import PropTypes from 'prop-types';
import SectionEyebrow from '../../atoms/SectionEyebrow';
import './index.scss';

export default function EditorialSectionHead({
  eyebrow,
  title,
  side,
  action,
  className = '',
}) {
  const classes = ['editorial-section-head', className].filter(Boolean).join(' ');
  const hasAside = Boolean(side || action);
  return (
    <header className={classes}>
      <div className="editorial-section-head__main">
        <SectionEyebrow>{eyebrow}</SectionEyebrow>
        <h2 className="editorial-section-head__title">{title}</h2>
      </div>
      {hasAside ? (
        <div className="editorial-section-head__aside">
          {side ? <p className="editorial-section-head__side">{side}</p> : null}
          {action ? <div className="editorial-section-head__action">{action}</div> : null}
        </div>
      ) : null}
    </header>
  );
}

EditorialSectionHead.propTypes = {
  eyebrow: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  side: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};
